import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TariffZonesEntityGrid } from '../features/tariff-zones-entity-grid/tariff-zones-entity-grid';

export const AllTariffZonesPage = observer(() => {
  return (
    <AppPage perm="PERM_ROUTE_READ" noWrapper>
      <TariffZonesEntityGrid />
    </AppPage>
  );
});
